import { trustHTML } from "@ember/template";
import DButton from "discourse/ui-kit/d-button";
import DModal from "discourse/ui-kit/d-modal";
import { i18n } from "discourse-i18n";

const DeleteTopicDisallowed = <template>
  <DModal @closeModal={{@closeModal}}>
    <:body>
      <p>{{trustHTML (i18n "post.controls.delete_topic_disallowed_modal")}}</p>
    </:body>
    <:footer>
      <DButton @action={{@closeModal}} class="btn-primary" @label="close" />
    </:footer>
  </DModal>
</template>;

export default DeleteTopicDisallowed;
